import { axiosInstance, handleApiRequest } from './apiClient';
import { UploadedFileInfo, UploadFilesParams } from 'types/upload';


const uploadAPI = {
  uploadFiles: async ({ sessionId, files }: UploadFilesParams) => {
    const formData = new FormData();
    formData.append('sessionId', sessionId);

    files.forEach(file => {
      formData.append('files', file);
    });

    return handleApiRequest<UploadedFileInfo[]>(
      axiosInstance.post('/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      })
    );
  }
};

export default uploadAPI;
